export default __webpack_public_path__ + "static/media/tree_1_anim.006c1a14.gif";